export default __webpack_public_path__ + "static/media/lagos.9ea39209.png";